import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom'
import {isMobile} from 'react-device-detect';
// import '../../styles/spacing'



class Chip extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);
   
    this.state = {
      isHovered: false
      // isToggled: false
    };

    // This binding is necessary to make `this` work in the callback
    this.handleHover = this.handleHover.bind(this);
    // this.handleClick = this.handleClick.bind(this);
  }

  handleHover = () => this.setState({ isHovered: !this.state.isHovered });
  
  //   handleClick() {
  //   this.setState(prevState => ({
  //     isToggled: !prevState.isToggled
  //   }));
  // }

  render() {
    const { content, cx, absolute, center, linkTo } = this.props;
    
    const cxPos = absolute ? "pos-absolute bottom-medium" : "";
    const cxCenter = center ? "center-absolute left-50" : "";

    return (
      // <Link to={linkTo} className={` flex height-fit ba br-100 bg ${cxCenter} ${cxPos} ${cx} ${this.state.isHovered ? "bg-hover" : ""} `} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}>
      <Link to={linkTo} className={` flex height-fit ba br-100 bg ${cxCenter} ${cxPos} ${cx} ${this.state.isHovered ? "bg-hover" : ""} `} onMouseEnter={isMobile ? null : this.handleHover} onMouseLeave={isMobile ? null : this.handleHover} onFocus={isMobile ? this.handleHover : null }>
        <label className="pt-xs pr-s pb-xs pl-s">{content}</label>
      </Link>
    
    );
  }
}


export default Chip;

// pos-absolute bottom-medium center-absolute left-50